import { useMemo } from 'react';
import { Typography } from 'react-md';
import { useAppSelector } from '@app/hooks';
import { TbdLabelWithPrice } from '@components/tbd';
import { selectCurrency } from '@modules/app';
import { selectWidgetMaterial } from '@modules/quotation';
import { selectBulkPrices } from '@modules/pricing';
import { getBulkPriceCellValue } from './helpers';

interface GetPriorityOptionsProps {
    count: number;
}

export function useGetPriorityOptions({ count }: GetPriorityOptionsProps) {
    const { lead_time: priorities } = useAppSelector(selectWidgetMaterial) || {};
    const bulkPrices = useAppSelector(selectBulkPrices);
    const currency = useAppSelector(selectCurrency);

    const memoizedPriorities = useMemo(() => {
        return priorities?.map(item => {
            const bulkPrice = bulkPrices?.find(price => price.priority_id === item.id);
            const priceItem = bulkPrice?.priority_prices.find(item => item.quantity === count);
            const isTbd = Boolean(priceItem?.tbd_reason);

            return {
                label: item.name_for_user || item.display_name,
                value: item.id,
                rightAddon: priceItem ? (
                    <TbdLabelWithPrice isTbd={isTbd}>
                        <Typography type="subtitle-2" component={'span'}>
                            {getBulkPriceCellValue(priceItem, currency)}
                        </Typography>
                    </TbdLabelWithPrice>
                ) : null,
            };
        });
    }, [priorities, bulkPrices, count, currency]);

    return memoizedPriorities;
}
